/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../table/table';
import TableRegisterButton from '../table/registerButton';
import LeadTimeAction from '../../app/store/actions/leadTime';
import ModalComponent from '../modal';

import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';

class LeadTimePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'ASC',
      field: 'id',
      showModal: false,
      show: false,
    };
  }

  componentDidMount() {
    this.searchPlace();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchPlace();
  };

  searchPlace = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, search, false, orderBy, field);
  };

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchPlace();
  };

  deletePlaceModal = async (placeId) => {
    await this.setState({ selectItemToDelete: placeId, showModal: true });
  };

  deleteLeadTime = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.deleteLeadTime(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchPlace();
      this.deleteNotification();
    }
  };

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => {
      this.setState({ show: false });
    }, 5000);
  };

  render() {
    const { limit, page, showModal } = this.state;
    const { leadTimes = [] } = this.props;

    const tableHeader = [
      {
        key: 'distributionCenterCode',
        value: I18n.t('distributionCenterCode'),
      },
      { key: 'storeBranchCode', value: I18n.t('storeBranchCode') },
      { key: 'transferLeadTimeDays', value: I18n.t('transferLeadTimeDays') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = leadTimes.count > 0
      && leadTimes.rows.map((row, index) => {
        const distributionCenterCode = row.distributionCenterCode || '';
        const storeBranchCode = row.storeBranchCode || '';
        const transferLeadTimeDays = row.transferLeadTimeDays || '';

        return {
          key: row.id,
          id: row.id,
          distributionCenterCode,
          storeBranchCode,
          transferLeadTimeDays,
          action: (
            <div
              key={`${row.id}_${index}`}
              className="btn-group"
              role="group"
              aria-label="Button group with nested dropdown"
            >
              <div className="btn-group" role="group">
                <button
                  id="btnGroupDrop1"
                  type="button"
                  className="btn btn-secondary dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <Translate value="action" />
                </button>
                <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                  <button
                    type="button"
                    className="dropdown-item dropdown-table"
                    onClick={() => history.push({
                      pathname: ROUTES.PARAMETERS_LEAD_TIME_FORM,
                      screenComming: 'parameters',
                      rowData: row,
                    })
                    }
                  >
                    <Translate value="edit" />
                  </button>
                  <button
                    type="button"
                    className="dropdown-item dropdown-table"
                    onClick={() => this.deletePlaceModal(row.id)}
                  >
                    <Translate value="delete" />
                  </button>
                </div>
              </div>
            </div>
          ),
        };
      });

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton
          route={{
            pathname: ROUTES.PARAMETERS_LEAD_TIME_FORM,
            screenComming: 'parameters',
          }}
        />
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('delete')}
          body={I18n.t('deleteLeadTime')}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deleteLeadTime}
        />

        {leadTimes.count > 0 && (
          <Table
            title={I18n.t('LeadTime (CD x Sucursal)')}
            buttons={tableButtons}
            header={tableHeader}
            lines={tableData}
            page={page}
            perPage={limit}
            count={leadTimes && leadTimes.count}
            searchItems={this.updateValues}
            showItemsCount
            sortTable={this.sortTable}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, search, force, order, field) => dispatch(
    LeadTimeAction.getLeadTimes(limit, skip, search, force, order, field),
  ),
  deleteLeadTime: id => dispatch(LeadTimeAction.deleteLeadTime(id)),
});

const mapStateToProps = state => ({
  leadTimes: state.leadTimes && state.leadTimes.leadTimes,
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadTimePage);
